import BaseAPIService from '../base/base-api-service';
import CreditCardModel from 'src/model/creditCard.model';

export interface IInvoicePayment {
  orderNumber: number;
  paymentAmount: number;
  reasonRemainingBalance: string;
  transactionId: number;
}

class CreditCardService extends BaseAPIService<CreditCardModel> {
  public endpoint: string = '/cartapp/v1/creditcard';

  constructor() {
    super(CreditCardModel);
  }

  public getSavedCreditCards(): Promise<CreditCardModel[]> {
    return this.getByParams(`${this.endpoint}/savedcards`, {}, {});
  }

  public payInvoices(
    invoicePayments: IInvoicePayment[],
    creditCardProfile: string
  ) {
    return new Promise((resolve, reject) => {
      this.doRequest({
        baseURL: this.baseURL,
        method: 'POST',
        url: '/accountapp/v1/creditcard/pay/invoice',
        data: {
          invoicePayments,
          creditCardProfile
        }
      })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const creditCardServiceInstance = new CreditCardService();
Object.freeze(creditCardServiceInstance);

export default creditCardServiceInstance;
